const styles = {
  containerSx: { mt: { xs: "-56px", md: "-64px" } },

  contactStripSx: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: { xs: "column", sm: "row" },
    gap: { xs: 3, sm: 0 },
    backgroundColor: "#0d0d0d",
    borderRadius: "12px",
    px: { xs: 3, md: 6 },
    py: { xs: 4, md: 5 },
  },

  contactLabelSx: {
    color: "rgba(255,255,255,0.4)",
    fontSize: "0.7rem",
    fontWeight: 700,
    letterSpacing: "0.18em",
    textTransform: "uppercase",
    mb: 0.5,
  },

  contactTitleSx: {
    color: "white",
    fontWeight: 700,
    fontSize: { xs: "1.5rem", md: "2rem" },
    letterSpacing: "-0.02em",
    lineHeight: 1.1,
  },

  contactButtonSx: {
    px: { xs: 4, md: 5 },
    height: { xs: 48, md: 52 },
    fontSize: { xs: 13, md: 14 },
    letterSpacing: "0.05em",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
};

export default styles;
